
const getCookie = name => {
  const nameWithEquals = name + '=';
  const cookie = (decodeURIComponent(document.cookie || '').split(';') || [])
    .map(cookie => cookie.trim())
    .find(cookie => cookie.indexOf(nameWithEquals) === 0);
  return cookie ? cookie.substring(nameWithEquals.length) : null;
};

const cookieUtils = {
  getCookie,
};
export default cookieUtils;
